import React from 'react';

import LocalizedLink from 'components/LocalizedLink';
import Logo from 'components/Logo';
import SiteFooter from 'components/SiteFooter';
import { useI18n } from 'i18n/I18nContext';
import background from 'static/images/background@2x.jpg';

const NotFoundPage = () => {
  const { t } = useI18n();

  return (
    <div
      className="w-screen min-h-screen flex flex-col bg-white"
      style={{
        background: `url(${background})`,
        backgroundSize: 'cover',
      }}
    >
      <div className="w-full p-25">
        <Logo />
      </div>

      <div className="flex-1 flex justify-center items-center py-50 px-15">
        <div className="w-500 max-w-full text-white opacity-90 text-center">
          <h1 className="text-2xl font-bold">{t('notFound.title')}</h1>
          <p className="mt-25">
            <LocalizedLink
              to="/"
              className="text-white no-underline font-bold border-b border-white border-opacity-50"
            >
              {t('notFound.backHome')}
            </LocalizedLink>
          </p>
        </div>
      </div>

      <SiteFooter />
    </div>
  );
};

export default NotFoundPage;



// WEBPACK FOOTER //
// ./src/pages/404.tsx